import React, { FC }              from 'react';
import { TDataTableRow }          from '@typings/components';
import { ESTIMATE_TABLE_HEADERS } from '@modules/invoiceManagement/utils/tableHeaders';
import {
  DataTable,
  SearchPagination,
}                                 from '@components/index';

interface IProps {
  rowInvoiceData     : TDataTableRow[];
  totalInvoicesCount : number;
  currentPage        : number;
  rowsPerPage        : number;
  isLoading          : boolean;
  handleChangePage   : (page: number) => void;
}

export const EstimateInvoicePage: FC<IProps> = ({
  rowInvoiceData,
  totalInvoicesCount,
  currentPage,
  rowsPerPage,
  isLoading,
  handleChangePage,
}) => (
  <>
    <DataTable
      headers  = {ESTIMATE_TABLE_HEADERS}
      rows     = {rowInvoiceData}
      loading  = {isLoading}
      maxwidth = "900px"
    />

    {!!totalInvoicesCount && (
      <SearchPagination
        totalItems       = {totalInvoicesCount}
        currentPage      = {currentPage}
        rowsPerPage      = {rowsPerPage}
        handleChangePage = {handleChangePage}
        maxWidth         = "900px"
      />
    )}
  </>
);
